import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IBill } from "../interface/IBill";
import { differenceInMilliseconds } from "date-fns";
import { getBillHistoryRoute } from "@api-routes/billing";
import { IBillResponse, getResponseToState } from "../mappers/getBillListMapper";
import { useFetch } from "@common/hook/useFetch";

interface IParams {
    accountId: string;
}

export const useBillList = (props: IParams) => {
    const { accountId } = props;
    const [billList, setBillList] = useState<IBill[]>([]);
    const { t } = useTranslation("bills");

    const [getBillListState, { get }] = useFetch();
    const [errorMessage, setErrorMessage] = useState("");

    const getBillList = () => {
        get<IBillResponse[]>(getBillHistoryRoute(accountId), {
            forwardError: true,
        })
            .then((billListResponse) => {
                const billListMapped = getResponseToState(billListResponse);

                if (billListMapped) {
                    billListMapped.sort((bill1, bill2) => {
                        const bill1Date = new Date(bill1.invoiceDate);
                        const bill2Date = new Date(bill2.invoiceDate);

                        return differenceInMilliseconds(bill2Date, bill1Date);
                    });

                    setBillList(billListMapped);
                } else {
                    setErrorMessage(t("noBill"));
                }
            })
            .catch(() => {
                setErrorMessage(t("noBill"));
            });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getBillList, []);

    return { billList, getBillListState, errorMessage };
};
